export enum CallbackStatuses {
  active = 'active',
  disabled = 'disabled',
}
